export const concatPermission = (menu, permission) => {
    return `${menu}:${permission}`;
};

export function CheckPermissionComponent({ permissionConstant, userPermission, children }) {
    if (!Array.isArray(permissionConstant)) {
        return null
    }

    for (const permissionName of permissionConstant) {
        const [menu, permission] = permissionName.split(":")
        const userPermissionMap = userPermission[menu]

        if (userPermission["all"] !== undefined) {
            return children
        }

        if (userPermissionMap === undefined || !userPermissionMap.includes(permission)) {
            continue
        }

        return children
    }

    return null
}

export function CheckPermissionApi(permissionConstant, userPermission) {
    const [menu, permission] = permissionConstant.split(":")
    const userPermissionMap = userPermission[menu]

    if (userPermission["all"] !== undefined) {
        return true
    }

    if (userPermissionMap === undefined || !userPermissionMap.includes(permission)) {
        return false
    }

    return true
}